/**
 * 距離(単位はm)
 */
export const CHECKIN_DISTANCE = 200;
export const MISSION_DISTANCE = 200;
export const PHOTO_MISSION_DISTANCE = 200;
export const QUIZ_MISSION_DISTANCE = 200;

/**
 * 再チャレンジ可能間隔
 * 経過日で計算
 * 『現在日 - 過去の達成日 < ここの設定値』
 * 0: 0日経過したら再チャレンジ可能（当日中の再チャレンジが可能）
 * 1: 1日経過したら再チャレンジ可能（翌日から再チャレンジが可能）
 * 2: 2日経過したら再チャレンジ可能
 */
export const CHECKIN_INTERVAL = 1;
export const PHOTO_MISSION_INTERVAL = 1;
export const QUIZ_MISSION_INTERVAL = 1;
export const TICKET_INTERVAL = 1;

export const AGE_LIST = [
  "10代",
  "20代",
  "30代",
  "40代",
  "50代",
  "60代",
  "70代以上",
  "回答しない",
];
export const SYUKUHAKU_LIST = ["宿泊", "日帰り", "回答しない"];
export const KITAKU_LIST = [
  "12時以前",
  "13時",
  "14時",
  "15時",
  "16時",
  "17時",
  "18時",
  "19時",
  "20時",
  "21時",
  "22時以降",
  "回答しない",
];
export const FELLOW_NUMBER_LIST = [
  "なし",
  "1人",
  "2人",
  "3人",
  "4人",
  "5人以上",
  "回答しない",
];
export const FELLOW_LIST = [
  "1人",
  "家族（夫婦）",
  "家族（小学生までの子どもあり）",
  "家族（三世代）",
  "家族（その他）",
  "友人・知人",
  "恋人",
  "仕事仲間",
  "地域などの団体",
  "その他",
  "回答しない",
];
export const YAMANASHI_VISIT_NUMBER = [
  "はじめて",
  "2回",
  "3回",
  "4回",
  "5回以上",
  "山梨県在住",
  "回答しない",
];
export const PREF_LIST = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
  "回答しない",
];
export const SPOT_EX_LIST = [
  {
    img: "spots/camera.svg",
    text: "観光",
  },
  {
    img: "spots/spa.svg",
    text: "温泉",
  },
  {
    img: "spots/restaurant.svg",
    text: "食事",
  },
  {
    img: "spots/experience.svg",
    text: "体験",
  },
  {
    img: "spots/shopping.svg",
    text: "お土産",
  },
];

export const PARSONALIZE_TAG_LIST = [
  {
    id: 1,
    text: "子供連れにおすすめ",
  },
  {
    id: 2,
    text: "お一人様におすすめ",
  },
  {
    id: 3,
    text: "男性におすすめ",
  },
  {
    id: 4,
    text: "女性におすすめ",
  },
  {
    id: 5,
    text: "若者向け",
  },
  {
    id: 6,
    text: "シニア向け",
  },
  {
    id: 7,
    text: "キャンペーン",
  },
];

export const FILTER_DISTANCE_LIST = [
  {
    distance: 3000,
    text: "3km以内",
  },
  {
    distance: 6000,
    text: "6km以内",
  },
  {
    distance: 10000,
    text: "10km以内",
  },
  {
    distance: 20000,
    text: "20km以内",
  },
];

export const IC_LIST_BEFORE = [
  "小牧JCT",
  "小牧東IC",
  "多治見IC",
  "土岐JCT",
  "土岐IC",
  "瑞浪IC",
  "恵那IC",
  "中津川IC",
  "神坂スマートIC",
  "園原IC",
  "飯田山本IC",
  "飯田IC",
  "飯田JCT",
  "座光寺スマートIC",
  "松川IC",
  "駒ヶ岳スマートIC",
  "駒ヶ根IC",
  "小黒川スマートIC",
  "伊那IC",
  "伊北IC",
  "辰野PA",
  "岡谷JCT",
  "諏訪IC",
  "諏訪南IC",
  "小淵沢IC",
  "長坂IC",
  "須玉IC",
  "韮崎IC",
  "双葉JCT",
  "双葉スマートIC",
  "甲府昭和IC",
  "甲府南IC",
  "笛吹八代スマートIC",
  "一宮御坂IC",
  "勝沼IC",
  "大月JCT",
  "大月IC",
  "県道49号",
  "国道248号",
  "中山道/国道21号",
  "県道47号",
  "恵那白川かえで街道/県道68号",
  "中山道/中津川バイパス/国道19号",
  "国道153号/国道256号",
  "国道474号",
  "飯田バイパス/国道153号",
  "飯田市道2-64号",
  "県道59号",
  "駒ヶ根市道駒ヶ岳スマートインター線",
  "県道75号",
  "市道荒井横山線",
  "県道476号",
  "三州街道/伊那街道/国道153号",
  "諏訪バイパス/国道20号",
  "県道90号",
  "県道11号",
  "県道32号",
  "清里ライン/国道141号",
  "昇仙峡グリーンライン/県道27号",
  "甲州街道/甲府バイパス/国道20号",
  "精進ブルーライン/国道358号",
  "県道313号",
  "御坂みち/国道137号",
  "勝沼バイパス/甲州街道/国道20号",
  "甲州街道/国道20号",
  "甲州街道/国道20号",
  "大月バイパス",
];

export const IC_LIST_AFTER = [
  "八王子JCT",
  "八王子IC",
  "国立府中IC",
  "府中スマートIC",
  "稲城IC",
  "調布IC",
  "高井戸IC",
  "首都高速４号新宿線",
  "高井戸",
  "永福",
  "幡ヶ谷",
  "初台",
  "西新宿JCT",
  "新宿",
  "代々木",
  "外苑",
  "三宅坂JCT",
  "芝浦JCT",
  "浜崎橋JCT",
  "汐留JCT",
  "京橋JCT",
  "江戸橋JCT",
  "神田橋JCT",
  "竹橋JCT",
  "三宅坂JCT",
  "谷町JCT",
  "一ノ橋JCT",
  "石川町JCT",
  "本牧JCT",
  "金港JCT",
  "大黒JCT",
  "生麦JCT",
  "川崎浮島JCT",
  "大師JCT",
  "昭和島JCT",
  "東海JCT",
  "葛西JCT",
  "辰巳JCT",
  "箱崎JCT",
  "両国JCT",
  "東雲JCT",
  "有明JCT",
  "大井JCT",
  "大橋JCT",
  "西新宿JCT",
  "板橋JCT",
  "熊野町JCT",
  "江北JCT",
  "小菅JCT",
  "堀切JCT",
  "三郷JCT",
  "美女木JCT",
  "西銀座JCT",
  "川口JCT",
  "横浜港北JCT",
  "横浜青葉JCT",
  "高谷JCT",
  "小松川JCT",
];



// WEBPACK FOOTER //
// ./src/const.js